<template>
    <div>
        <div class="row d-flex align-items-center mt-5">
            <div class="col-sm-6">
                <h4>Kategorijas</h4>
            </div>
            <div class="col-sm-6 d-flex justify-content-end">
                <CategoriesAdd/>
            </div>
        </div>
        <CategoriesList/>
    </div>
</template>
<script>
    import {SkeletonLoaderRepository} from '../global/skeleton-loader/SkeletonLoaderRepository';
   
    import CategoriesList from './CategoriesList';
    import CategoriesAdd from './CategoriesAdd';

    export default {
        name: 'categories',
        components: {CategoriesList, CategoriesAdd},
        data: () => ({skeletonData: SkeletonLoaderRepository.usersListLayout}),
    }
</script>